import ICONS from "../../../assets/Icons";
import TEXT from "../../../utils/globalText";
import "./index.css";
import SVGComponent from "../../_utils/SVGComponent";
import AdditionalDetailsPreviewMapper from "../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../_utils/TransactionCommonComponents/Amount";
import ConfidentialCard from "../../_utils/TransactionCommonComponents/ConfidentialCard";
import NameFieldCard from "../../_utils/TransactionCommonComponents/NameFieldCard";
import PaymentMethodSelector from "../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";
import TransactionOccurrenceDetails from "../../_utils/TransactionCommonComponents/TransactionOccurrenceDetails";
import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";
import ScheduleInternalTransactionViewSchedule from "../../../containers/ScheduleInternalTransaction/ScheduleInternalTransactionViewSchedule";
import CommonLayout from "../../_utils/CommonLayout";

const ScheduleInternalTxnConfirmSchedule = (props) => {
  const formatDate = (date) => {
    const dates = new Date(date || new Date());
    const day = dates.toLocaleDateString("en-GB", {
      day: "2-digit",
    });
    const month = dates.toLocaleDateString("en-GB", {
      month: "short",
    });
    const year = dates.toLocaleDateString("en-GB", {
      year: "numeric",
    });
    return `${day} ${month}, ${year}`;
  };

  return (
    <>
      {props?.showSimilarModal && (
        <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="Similar transactions found"
            isHeaderImgNeed={true}
            ShowIcon={ICONS.ALERT}
            headersubtext="Transactions with similar details have already been created. Proceeding will result in a duplicate transaction."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => props?.setShowSimilarModal(false)}
            closeicon={
              "https://q2pay.in/new_assets/common/create_flow/close.svg"
            }
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            confirmbtnrequired={true}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            isbottomSectionneed={true}
            bottomHeaderTextNeed={true}
            btnText="Proceed with caution"
            handleFunction={() => {
              props?.setShowSimilarModal(false);
              props?.onForceCreate();
            }}
            bottomHeaderText={"Proceed with creating this transaction?"}
          >
            <ScheduleInternalTransactionViewSchedule
              onClose={() => props?.setShowSimilarModal(false)}
              txnHistorytype={"internalScheduleCreateTxn"}
              duplicateFilters={props?.buildDuplicateCheckPayload}
              destination_account_number={props?.txnPayLoad?.bankAccountNo}
              source_account_number={props?.txnPayLoad?.ownerBankAccountNo}
              txnPayLoad={props?.txnPayLoad}
            />
          </LargePopupRedirect>
        </div>
      )}
      <div
        className={`w-width-full Qlg:px-padding-base px-padding-md Qsmd:py-padding-lg pt-padding-md max-w-tab-width-normal mx-auto`}
      >
        <CommonLayout>
          <SourceDestinationAccountDetail
            type="source"
            txnPayLoad={props.txnPayLoad}
            setTxnPayLoad={props.setTxnPayLoad}
            page="confirm"
          />

          <SourceDestinationAccountDetail
            type="destination"
            flow="internalTxn"
            txnPayLoad={props.txnPayLoad}
            setTxnPayLoad={props.setTxnPayLoad}
            page="confirm"
          />

          <div className="w-width-full flex flex-col gap-gap-md">
            <Amount
              isPreview={true}
              txnPayLoad={props?.txnPayLoad}
            />

            <PaymentMethodSelector
              previewMode={true}
              showUnassignLink={false}
              selectedMethod={props?.txnPayLoad?.settleType}
            />
          </div>

          <div className="w-width-full flex flex-col gap-gap-md">
            <NameFieldCard
              title={TEXT?.SCHEDULE_NAME}
              value={props?.txnPayLoad.scheduled_name}
              previewMode={true}
            />

            <ConfidentialCard
              icon={ICONS?.CONFIDENTIAL_TRANSACTION}
              title={TEXT?.CREATE_AS_CONFIDENTIAL}
              note={TEXT?.CONFIDENTIAL_SCHEDULE_TRANSACTION_NOTE}
              toggleState={props?.isConfidential}
              isPreview={true}
            />
          </div>

          <TransactionOccurrenceDetails
            txnPayLoad={props?.txnPayLoad}
            formatDate={formatDate}
            SlotMappingData={props?.SlotMappingData}
            previewMode={true}
          />

          <AdditionalDetailsPreviewMapper
            mappingData={props.txnPayLoad.mergeCategory}
            previewImages={props?.previewImages}
          />
        </CommonLayout>
      </div>
    </>
  );
};

export default ScheduleInternalTxnConfirmSchedule;
